import { render, staticRenderFns } from "./PersonFilmography.vue?vue&type=template&id=1116b87c&scoped=true&"
import script from "./PersonFilmography.vue?vue&type=script&lang=js&"
export * from "./PersonFilmography.vue?vue&type=script&lang=js&"
import style0 from "./PersonFilmography.vue?vue&type=style&index=0&id=1116b87c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1116b87c",
  null
  
)

export default component.exports